module.exports = __webpack_public_path__ + "img/Neiin.81000b7c.jpg";